import axiosService from "services/axios.service";

export interface LoginPayload {
  email: string;
  password: string;
}

export const login = async (payload: LoginPayload): Promise<any> => {
  const response = await axiosService.post("v1/admin/auth/login", payload);
  return response?.data?.data;
};
